// extracted by mini-css-extract-plugin
export default {"root":"R6j4M","text":"_2M5yy","buttonsContainer":"_11Q6q","button":"_2_llO"};